module.exports = __webpack_public_path__ + "img/home.ba929601.svg";